// Registro de diagnóstico de la sesión y la versión del frontend (consola + últimos 50 eventos en sessionStorage).
// Nunca recibe contraseñas, tokens ni datos personales: solo el evento y datos técnicos (rol, estado HTTP, intento, versión).
const CLAVE = 'diagnostico_sesion';
const MAX = 50;

export function diag(area, evento, datos = {}) {
  const linea = { t: new Date().toISOString(), area, evento, ...datos };
  try { if (process.env.NODE_ENV !== 'test') console.info(`[${area}] ${evento}`, datos); } catch {}
  try {
    const lista = JSON.parse(sessionStorage.getItem(CLAVE) || '[]');
    lista.push(linea);
    sessionStorage.setItem(CLAVE, JSON.stringify(lista.slice(-MAX)));
  } catch {}
}

/** Para soporte: window.__diagnosticoSesion() en la consola del navegador. */
export const leerDiagnostico = () => { try { return JSON.parse(sessionStorage.getItem(CLAVE) || '[]'); } catch { return []; } };
if (typeof window !== 'undefined') window.__diagnosticoSesion = leerDiagnostico;
